import type { FC } from 'react';
import React from 'react';
import { format } from 'date-fns';
import ruLocale from 'date-fns/locale/ru';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';
import { pluralizePerson } from 'src/utils/pluralizeUtils';
import { Button } from '@lt/components';

interface Props {
  cityFrom: string;
  startDate?: Date;
  endDate?: Date;
  adults: number;
  kidsCount: number;
  onExpand(): void;
  className?: string;
  isHotelOnly: boolean;
}

const SearcherFormClamped: FC<Props> = ({
  cityFrom,
  startDate,
  endDate,
  adults,
  kidsCount = 0,
  onExpand,
  className = '',
  isHotelOnly,
}) => {
  const { t } = useTranslation();
  const startDateFormattedFns =
    startDate &&
    format(startDate, 'd MMMM', {
      locale: ruLocale,
    });
  const endDateFormattedFns =
    endDate && format(endDate, 'd MMMM', { locale: ruLocale });

  return (
    <StyledContainer className={className}>
      <StyledH2>
        {`${t('hotel.cigarette.mobile.startDate')}${startDateFormattedFns} `}
        {`${t('hotel.cigarette.mobile.endDate')}${endDateFormattedFns}`}
        {' · '}

        {`${adults + kidsCount} ${pluralizePerson(adults + kidsCount)}`}
        <br />
        {!isHotelOnly && `${t('hotel.cigarette.mobile.from')} ${cityFrom}`}
      </StyledH2>
      <StyledButton onClick={onExpand}>
        {t('hotel.cigarette.mobile.buttonChange')}
      </StyledButton>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledH2 = styled.h2`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  color: ${(props) => props.theme.colors.blackBase};
`;

const StyledButton = styled(Button).attrs({ functional: true })`
  color: ${(props) => props.theme.colors.blue};
  text-align: left;
  font-size: 14px;
  margin-top: 8px;
`;

export default SearcherFormClamped;
